export const TERMS_VERSION = '2026-10-07';

export const PAYMENT_TERMS_SECTIONS = [
  {
    key: 'fees',
    title: 'Fees & Medicare rebates',
    body: [
      {
        text: 'You accept the medical consultation fee shown above, which was quoted to you during booking.',
      },
      {
        text: "Your Medicare rebate may vary based on your eligibility. If you're eligible for a rebate, we lodge the patient claim on your behalf within 3 business days of you attending your appointment. Medicare then pays the rebate straight into your nominated bank account.",
      },
      {
        text: "The final Medicare item code is determined at the clinician's discretion and may differ from the pre-quoted fee. We'll contact you to adjust the payment and rebate accordingly after your appointment.",
      },
    ],
  },
  {
    key: 'prepayment',
    title: 'Prepayment',
    body: [
      {
        text: 'Payment is made through the link Telecare sends you after you book. If we have not received your payment 3 business days before your appointment, we will send you a reminder. Appointments that remain unpaid may be cancelled or rescheduled.',
      },
    ],
  },
  {
    key: 'cancellations',
    title: 'Cancellation Policy',
    body: [
      {
        text: 'Please understand that our specialists and your GPs have reserved their time for you. If you must cancel your appointment, we respectfully request 2 business days notice so we have time to organise another patient who needs this service.',
      },
      {
        text: 'Missed appointments, or appointments cancelled without valid medical reason within 2 business days of the appointment will incur a fee ($150).',
      },
    ],
  },
  {
    key: 'privacy',
    // Legal-approved wording from the v1 payment page: keep it word for word.
    title: 'Disclaimer and Consent',
    body: [
      {
        lead: 'Service Confirmation:',
        text: 'Payment does not guarantee the availability of the service. In the event of any changes, such as Medicare item code updates or appointments adjustments by clinicians, additional fees or refunds will be processed accordingly.',
      },
      {
        lead: 'Secure Payment:',
        text: 'The PAY NOW function is securely processed by Pin Payments, an Australian-based payment gateway. All credit card details will be collected by Pin Payments and not stored with Telecare.',
      },
      {
        lead: 'Pre-Payment Authorization:',
        text: 'You authorize us to charge the specified amount to your selected payment method.',
      },
      {
        lead: 'Data Processing:',
        text: 'You consent to the processing of your personal data for the purpose of completing this transaction, in accordance with our Privacy Policy.',
      },
      {
        lead: 'Communication:',
        text: 'You agree to receive communication related to your payment and services via email or phone.',
      },
    ],
  },
];

// Shown with the payment terms for information; not a section to tick.
export const PAYMENT_BANK_TRANSFER = {
  title: 'Bank Transfer',
  text: "If you would like to use bank transfer, please contact us at invoice@telecare.com.au for details. Electronic funds transfers must be received into Telecare's account at least 3 business days prior to your appointment.",
};

export const TERMS_NOT_AGREED_MESSAGE =
  'Please read and tick each section above before you pay.';

export const BOOKING_TERMS_SECTIONS = [
  {
    key: 'financialConsent',
    title: 'Medical Consultation Financial Consent',
    body: [
      {
        text: 'You accept the medical service fee/s provided to you during the booking process and will contact Telecare to clarify fees and payment options if required and at least 2 business days before your appointment.',
      },
      {
        text: 'You agree to pay the full fee using the payment link Telecare sends you after you book. If we have not received your payment 3 business days before your appointment, we will send you a reminder. Appointments that remain unpaid may be cancelled or rescheduled.',
      },
      {
        text: 'If a payment is declined, you may be subject to a late payment administration fee.',
      },
    ],
  },
];

export const BOOKING_TERMS_NOT_AGREED_MESSAGE =
  'Please read and tick each section above before continuing.';

export const CANCELLATION_POLICY_SECTIONS = [
  {
    key: 'cancellationPolicy',
    title: 'Cancellation Policy',
    agreeLabel: 'Yes, I agree to the cancellation policy',
    body: [
      {
        text: 'Please understand that our specialists and your GPs have reserved their time for you. If you must cancel your appointment, we respectfully request 2 business days notice so we have time to organise another patient who needs this service.',
        emphasis: ['2 business days notice'],
      },
      {
        text: 'Missed appointments, or appointments cancelled without valid medical reason within 2 business days of the appointment will incur a fee ($150).',
        emphasis: ['2 business days', 'fee ($150)'],
      },
    ],
  },
];

export const CANCELLATION_POLICY_NOT_AGREED_MESSAGE =
  'Please agree to the cancellation policy before continuing.';
